export default ({ request }) => ({
  pendingGoodsPackageWorkLogListApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/package/work/log/pageList',
      method: 'post',
      data
    })
  },
  pendingGoodsPackageWorkLogSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/package/work/log/save',
      method: 'post',
      data
    })
  },
  pendingGoodsPackageWorkLogDetailApi(pendingGoodsPackageWorklogCode) {
    return request({
      url: `/factory/mrp/pending/goods/package/work/log/${pendingGoodsPackageWorklogCode}`,
      method: 'GET',
    })
  },
  pendingGoodsDetailApi(pendingGoodsCode) {
    return request({
      url: `/factory/mrp/pending/goods/${pendingGoodsCode}`,
      method: 'GET',
    })
  },
  pendingGoodsChooseListApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/chooseList',
      method: 'post',
      data
    })
  },
  pendingGoodsPackageWorkLogChangeGoodsApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/package/work/log/changeGoods',
      method: 'post',
      data
    })
  },
})
